module.exports = __webpack_public_path__ + "fonts/Inter-ExtraLight.woff2";